import { render, staticRenderFns } from "./ModalTemporaryStudentData.vue?vue&type=template&id=716841fe&scoped=true&lang=pug&"
import script from "./ModalTemporaryStudentData.vue?vue&type=script&lang=ts&"
export * from "./ModalTemporaryStudentData.vue?vue&type=script&lang=ts&"
import style0 from "./ModalTemporaryStudentData.vue?vue&type=style&index=0&id=716841fe&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716841fe",
  null
  
)

export default component.exports